import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.97" height="16.188" viewBox="0 0 17.97 16.188" className={props.className}>
            <path id="heart001_-_E034" data-name="heart001 - E034" d="M-4.923-45.96a5.244,5.244,0,0,0-3.792,1.645,5.244,5.244,0,0,0-3.792-1.645A5.157,5.157,0,0,0-17.7-40.828a5.189,5.189,0,0,0,1.432,3.579h.015l7.538,7.477,7.4-7.34A5.075,5.075,0,0,0,.27-40.828,5.157,5.157,0,0,0-4.923-45.96Zm0,.792a4.371,4.371,0,0,1,4.4,4.34,4.279,4.279,0,0,1-1.34,3.152l-6.853,6.792-6.99-6.929h.015a4.262,4.262,0,0,1-1.218-3.015,4.371,4.371,0,0,1,4.4-4.34,4.487,4.487,0,0,1,3.792,2.147A4.487,4.487,0,0,1-4.923-45.168Z" transform="translate(17.7 45.96)" fill="#fff"/>
        </svg>
    );
}